import { Controller } from "@hotwired/stimulus";

// Toggles notification panel visibility based on checkbox state.
// Used on both software_subscriptions and software_product_version forms.
export default class extends Controller {
  static targets = ["trigger", "panel", "warning", "confirmCheckbox"];

  changed() {
    const anyChecked = this.triggerTargets.some((cb) => cb.checked);

    if (anyChecked) {
      this.panelTarget.classList.remove("hidden");
      if (this.hasWarningTarget) this.warningTarget.style.display = "";
      if (this.hasConfirmCheckboxTarget) this.confirmCheckboxTarget.disabled = false;
    } else {
      this.panelTarget.classList.add("hidden");
    }
  }
}
